import React from 'react'
import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material'
import { useQueryClient } from '@tanstack/react-query'
import { useOktaAuth } from '@okta/okta-react'
import Transition from 'shared/Transition'
import { useTheme } from '../../../../utils/themeContext'
import { getColorsForTheme } from '../../../../global-styles/clientColors'

interface ListDelistModalProps {
  open: boolean
  onClose: () => void
  listDelistMutation: any
}

export const ListDelistModal: React.FC<ListDelistModalProps> = ({
  open,
  onClose,
  listDelistMutation,
}) => {
  const { authState } = useOktaAuth()
  const { currentTheme } = useTheme()
  const themeColors = getColorsForTheme(currentTheme)

  const queryClient = useQueryClient()
  const onClickListDelist = async () => {
    try {
      await listDelistMutation.mutateAsync()
    } catch (error) {
      console.log('error', error)
    } finally {
      onClose()
      queryClient.invalidateQueries('getVehicles')
    }
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      sx={{ minWidth: '20vw', padding: '15px 20px 20px 0', }}
    >
      <DialogTitle id="dialog-title">
        Would you like to list/delist this vehicle?
      </DialogTitle>

      <DialogActions>
        <Button
          variant="outlined"
          onClick={onClose}
          sx={{
            borderColor: themeColors.buttonColor,
            color: themeColors.buttonColor,
            '&:hover': {
              borderColor: themeColors.buttonHover,
              color: themeColors.buttonHover,
            },
          }}
        >
          Cancel
        </Button>
        {authState.isAuthenticated && (
          <Button
            onClick={() => onClickListDelist()}
            autoFocus
            variant="contained"
            color="primary"
            sx={{
              backgroundColor: themeColors.buttonColor,
              color: currentTheme === 'galpin' ? 'black' : 'white',
              '&:hover': {
                backgroundColor: themeColors.buttonHover,
              },
            }}
          >
            yes
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}
